import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import colorPaletteOutline from '../images/color-palette-outline.svg';
import colorPaletteGreyOutline from '../images/color-palette-grey.svg'
import blurimg from '../images/blur.svg'
import dotsimg from '../images/dots.svg'
import dotssquareimg from '../images/dots-square.svg'
import pattern from '../images/bg-pattern.svg'
import HowWeDoSection from '../page-sections/how-we-do-section';

function AboutUs() {
    const currentYear = new Date().getFullYear();
    return (
        <>


            <div id="home">
                <div className="cover-img position-relative h-40vh" style={{ background: 'rgba(190, 99, 249,0.6)' }} >
                    {/*, */}

                    {/* Design */}
                    <div className="d-flex pattern-img" style={{ backgroundImage: `url(${pattern})` }}>
                        {/* <div className="design-1"></div>
                            <div className="design-2"></div>
                            <div className="design-3"></div>
                            <div className="design-4"></div>
                            <div className="design-5"></div>
                            <div className="design-6"></div>
                            <div className="design-7"></div> */}
                    </div>


                    <div className="overlays glass">
                        {/* h-41rem */}
                        <Container fluid className="py-5">
                            <Row className="h-100 mt-3">
                                <Col md={10} className="mx-auto">
                                    <Row className="h-100">
                                        <Col md={12} lg={12} className="d-flex">
                                            <div className="text-white mt-5">
                                                {/* <span className="text-uppercase fs12  sub-title">We are Veeyaa Innovatives</span> */}
                                                <h1 className='page-title mt-4'>About <br /> Veeya Innovatives</h1>





                                                {/* <button className="btn btn-cards br-20px  px-4">Contact Us</button> */}
                                            </div>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>


            {/* Floating icons */}
            {/* <span className="fas fa-times floating-icon color-purple roate-alternative" style={{ top: '15%', right: '60px', fontSize: '60px' }}></span>
            <span className="fas fa-circle floating-icon  color-green beat-infinet" style={{ bottom: '120px', left: '25px', fontSize: '30px' }} ></span>
            <span className="far fa-square floating-icon  color-blue roate-infinet" style={{ top: '45%', left: '80px', fontSize: '20px' }}></span>

            <span className="fas fa-play floating-icon  color-yellow roate-infinet" style={{ fontSize: '60px', left: '30px', top: '5%' }}></span>

            <span className="fas fa-circle-notch floating-icon  color-red fs120 roate-infinet" style={{ bottom: '23%', right: '-50px' }}></span>



            <img src={dotssquareimg} alt="floating-icons" className="floating-icon position-absolute" style={{ width: '100px', left: '-5px', bottom: '50px' }} />
            <img src={blurimg} alt="floating-icons" className="floating-icon position-absolute" style={{ width: '160px', left: '-7px', top: '330px' }} />

            <img src={dotsimg} alt="floating-icons" className="floating-icon position-absolute" style={{ width: '160px', right: '-17px', bottom: '30px' }} />
 */}



            <Container className="my-5">
                <div className=" mb-5">

                    <Row>
                        <Col xl={12} md={12} className="mt-5 mt-lg-0">
                            <h2 className="pb-3 pt-2 text-center">The Story Behind Veeyaa</h2>

                            <h4 className='mb-3'>"Veeyaa" (வீயா) means ENDLESS in classical Tamil literature from the Sangam era.</h4>
                            <p className='color-grey3'>This ancient Tamil word symbolizes something that is unceasing, overflowing, and eternally abundant. It represents continuous flow and never-ending excellence.</p>
                            <p className='color-grey3'>That is why we chose the name Veeyaa Innovatives — to reflect our commitment to endless innovation and perpetual growth. Just as the word "Veeyaa" signifies the endless flow of excellence, we aim to deliver solutions that are rich in creativity, value, and longevity.</p>
                            <p className="text-left color-grey3">
                                A journey of passion, innovation, and excellence in software development since 2015.
                            </p>
                            <p className="text-left color-grey3">
                                Founded by Innovatives Group of Peoples and it has grown from a freelance practice to a comprehensive digital solutions provider, specializing in both academic and industrial projects.
                            </p>



                            <Row>
                                <Col lg={6}>
                                    <div className="d-flex align-items-center my-4 pt-3">
                                        <div className="circle-count">
                                            <span className="lnr lnr-history"></span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">On Time</h2>
                                            <p className="fs14 mb-0 color-grey3">Ensuring high-quality products are hand over to our customers on-time.</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center my-4">
                                        <div className="circle-count">
                                            <span className="lnr lnr-smile"></span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">User Friendly</h2>
                                            <p className="fs14 mb-0 color-grey3">Our mainly focused to design and develop the application based on the user Expectation.</p>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center my-4">
                                        <div className="circle-count">
                                            <span className="fs20">₹</span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">Best in Market</h2>
                                            <p className="fs14 mb-0 color-grey3">
                                                Our team analyse the fluctuation of the market price in local and international <br /> markets and ensured our customer to get more benefits.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center my-4">
                                        <div className="circle-count">
                                            <img src={colorPaletteGreyOutline} alt="color-pallet" />
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">Customizable</h2>
                                            <p className="fs14 mb-0 color-grey3">
                                                Based on the Technology trends and updates our software will always <br /> migratable &amp; upgradable
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="d-flex align-items-center my-4 pt-3">
                                        <div className="circle-count">
                                            <span className="lnr lnr-diamond"></span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">Perfection</h2>
                                            <p className="fs14 mb-0 color-grey3">Just like our name suggests, we strive for perfection in every project we undertake.</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center my-4">
                                        <div className="circle-count">
                                            <span className="lnr lnr-heart"></span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">Trust</h2>
                                            <p className="fs14 mb-0 color-grey3">Built on years of successful freelancing experience and satisfied clients.</p>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center my-4">
                                        <div className="circle-count">
                                             <span className="lnr lnr-magic-wand"></span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">Innovation</h2>
                                            <p className="fs14 mb-0 color-grey3">
                                                Combining traditional values with modern technological solutions.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center my-4">
                                        <div className="circle-count">
                                            <span className="lnr lnr-users"></span>
                                        </div>
                                        <div className="text-left ml-3">
                                            <h2 className="fs16 mb-1">Collaboration</h2>
                                            <p className="fs14 mb-0 color-grey3">
                                                Working closely with clients to understand and fulfill their needs.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>




                        </Col>
                    </Row>



                </div>
            </Container>

            <Container>

                <div className="blue-bg">
                    <h2 className="pb-3 pt-2 mb-5 text-center">Our Professional Journey</h2>
                    <div className="timeline-container">
                        {/* Timeline Item 1 - Left */}
                        <div className="timeline-item left">
                            <div className="timeline-content">
                                <h5>Starting the Freelance Journey</h5>
                                <p>Embarked on my freelancing career, focusing on software development and academic projects. This period was crucial in building a strong foundation in various programming languages and development methodologies.</p>
                            </div>
                            <div className="timeline-circle text-light-yellow">2015</div>
                            <div className="timeline-placeholder"></div>
                        </div>


                        {/* Timeline Item 2 - Right */}
                        <div className="timeline-item right">
                            <div className="timeline-placeholder"></div>
                            <div className="timeline-circle text-light-purple">2018</div>
                            <div className="timeline-content">
                                <h5>Academic Excellence</h5>
                                <p>Specialized in developing comprehensive solutions for college projects, helping students and institutions with technical implementations. Successfully delivered numerous projects in database management, web development, and software engineering.</p>
                            </div>
                        </div>

                        {/* Timeline Item 3 - Left */}
                        <div className="timeline-item left">
                            <div className="timeline-content">
                                <h5>Industrial Projects</h5>
                                <p>Expanded into industrial projects, working with businesses to develop custom software solutions. This period marked significant growth in understanding enterprise-level requirements and delivering scalable solutions.</p>
                            </div>
                            <div className="timeline-circle text-light-green">2020</div>
                            <div className="timeline-placeholder"></div>
                        </div>

                        {/* Timeline Item 4 - Right */}
                        <div className="timeline-item right">
                            <div className="timeline-placeholder"></div>
                            <div className="timeline-circle text-light-orange">2021</div>
                            <div className="timeline-content">
                                <h5>Founding Veeyaa Innovatives</h5>
                                <p>Established Veeyaa Innovatives, bringing together years of experience and a vision for perfect digital solutions. Built a talented team of freelancers to handle larger and more complex projects.</p>
                            </div>
                        </div>

                        {/* Timeline Item 5 - Left */}
                        <div className="timeline-item left">
                            <div className="timeline-content">
                                <h5>Growing Together</h5>
                                <p>Leading Veeyaa Innovatives to new heights, focusing on delivering innovative solutions while maintaining our commitment to quality and client satisfaction. Continuously expanding our expertise and project portfolio.</p>
                            </div>
                            <div className="timeline-circle text-light-pink">{currentYear}</div>
                            <div className="timeline-placeholder"></div>
                        </div>
                    </div>
                </div>
            </Container>

            <HowWeDoSection />
        </ >
    );
}

export default AboutUs;
